import { c as _c } from "react-compiler-runtime";
import { forwardRef, useEffect, useMemo } from 'react';
import { registerCustomFunction, unregisterCustomFunction } from 'nudge-client-utils';
import { PropertiesProvider as CustomerDataPropertiesProvider } from 'customer-data-properties/context';
import UserInfoProvider from 'marketing-platform-lib/providers/UserInfoProvider';
import AsyncListingLibDevTools from 'framework-listing-lib/internal/DevTools/components/AsyncListingLibDevTools';
import useOpenDevTools from 'framework-listing-lib/internal/DevTools/hooks/useOpenDevTools';
import ErrorBoundary from 'framework-listing-lib/internal/ErrorBoundary';
import CurrentViewProvider from 'framework-listing-lib/internal/ViewTabs/providers/CurrentViewProvider';
import { PinnedViewsBarClientProvider } from 'framework-listing-lib/internal/ViewTabs/providers/PinnedViewsBarClientProvider';
import ViewsProvider from 'framework-listing-lib/internal/ViewTabs/providers/ViewsProvider';
import usePerformanceTracking from 'framework-listing-lib/internal/hooks/usePerformanceTracking';
import CrmObjectTypeListingClientProvider from 'framework-listing-lib/internal/providers/CrmObjectTypeListingClientProvider';
import DataProvider from 'framework-listing-lib/internal/providers/DataProvider';
import ListingProvider from 'framework-listing-lib/internal/providers/ListingProvider';
import PropertiesProvider from 'framework-listing-lib/internal/providers/PropertiesProvider';
import TrackerProvider from 'framework-listing-lib/internal/providers/TrackerProvider';
import { MEASURE_MARK_NAMES } from 'framework-listing-lib/internal/utils/performanceTracking';
import { SENTRY_KEYS } from 'framework-listing-lib/utils/sentry';
import { DataWellSlotProvider } from 'framework-listing-lib/internal/providers/DataWellSlotProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FOLDERS_MODE_BUTTON_KEY = 'framework-listing-lib:click-folders-mode-button';
function FrameworkListingLibProvider(t0) {
  "use memo";

  const $ = _c(45);
  const {
    associationSpecs,
    calendarProps,
    children,
    emptyStateFilter,
    enableFieldLevelPermissions: t1,
    enableObjectLevelPermissions: t2,
    fetcher,
    folderProps,
    hiddenFilter,
    initialFilter,
    inlineEditProps,
    objectType,
    propertyOverride,
    typeDefinitionOverride,
    quickFilterProps,
    searchInputProps: _searchInputProps,
    trackerProps,
    uiModeProps,
    viewProps,
    showHighlySensitiveProperties,
    skipCrm,
    sortPropertyOverride,
    _useNonGqlCRMSearch
  } = t0;
  const enableFieldLevelPermissions = t1 === undefined ? false : t1;
  const enableObjectLevelPermissions = t2 === undefined ? false : t2;
  const [open] = useOpenDevTools();
  usePerformanceTracking(MEASURE_MARK_NAMES.LIFECYCLE);
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  useEffect(_temp3, t3);
  let t4;
  bb0: {
    if (_searchInputProps) {
      const t5 = typeof _searchInputProps.hasSearchInput === "boolean" ? _searchInputProps.hasSearchInput : true;
      let t6;
      if ($[1] !== _searchInputProps || $[2] !== t5) {
        t6 = Object.assign({}, _searchInputProps, {
          hasSearchInput: t5
        });
        $[1] = _searchInputProps;
        $[2] = t5;
        $[3] = t6;
      } else {
        t6 = $[3];
      }
      t4 = t6;
      break bb0;
    }
    let t5;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = {
        hasSearchInput: true
      };
      $[4] = t5;
    } else {
      t5 = $[4];
    }
    t4 = t5;
  }
  const searchInputProps = t4;
  const t5 = uiModeProps ? uiModeProps.onChangeUIMode : undefined;
  let t6;
  if ($[5] !== open) {
    t6 = open && /*#__PURE__*/_jsx(AsyncListingLibDevTools, {});
    $[5] = open;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== children || $[8] !== t5 || $[9] !== t6) {
    t7 = /*#__PURE__*/_jsxs(ViewsProvider, {
      onChangeUIMode: t5,
      children: [t6, children]
    });
    $[7] = children;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== associationSpecs || $[12] !== calendarProps || $[13] !== emptyStateFilter || $[14] !== fetcher || $[15] !== folderProps || $[16] !== hiddenFilter || $[17] !== initialFilter || $[18] !== inlineEditProps || $[19] !== quickFilterProps || $[20] !== searchInputProps || $[21] !== t7) {
    t8 = /*#__PURE__*/_jsx(CurrentViewProvider, {
      children: /*#__PURE__*/_jsx(DataWellSlotProvider, {
        children: /*#__PURE__*/_jsx(CrmObjectTypeListingClientProvider, {
          associationSpecs: associationSpecs,
          calendarProps: calendarProps,
          emptyStateFilter: emptyStateFilter,
          fetcher: fetcher,
          folderProps: folderProps,
          hiddenFilter: hiddenFilter,
          initialFilter: initialFilter,
          inlineEditProps: inlineEditProps,
          quickFilterProps: quickFilterProps,
          searchInputProps: searchInputProps,
          children: t7
        })
      })
    });
    $[11] = associationSpecs;
    $[12] = calendarProps;
    $[13] = emptyStateFilter;
    $[14] = fetcher;
    $[15] = folderProps;
    $[16] = hiddenFilter;
    $[17] = initialFilter;
    $[18] = inlineEditProps;
    $[19] = quickFilterProps;
    $[20] = searchInputProps;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== showHighlySensitiveProperties || $[24] !== t8) {
    t9 = /*#__PURE__*/_jsx(DataProvider, {
      showHighlySensitiveProperties: showHighlySensitiveProperties,
      children: t8
    });
    $[23] = showHighlySensitiveProperties;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== propertyOverride || $[27] !== sortPropertyOverride || $[28] !== t9 || $[29] !== typeDefinitionOverride) {
    t10 = /*#__PURE__*/_jsx(PropertiesProvider, {
      propertyOverride: propertyOverride,
      sortPropertyOverride: sortPropertyOverride,
      typeDefinitionOverride: typeDefinitionOverride,
      children: t9
    });
    $[26] = propertyOverride;
    $[27] = sortPropertyOverride;
    $[28] = t9;
    $[29] = typeDefinitionOverride;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  let t11;
  if ($[31] !== _useNonGqlCRMSearch || $[32] !== enableObjectLevelPermissions || $[33] !== objectType || $[34] !== skipCrm || $[35] !== t10 || $[36] !== uiModeProps || $[37] !== viewProps) {
    t11 = /*#__PURE__*/_jsx(PinnedViewsBarClientProvider, {
      children: /*#__PURE__*/_jsx(ListingProvider, {
        enableObjectLevelPermissions: enableObjectLevelPermissions,
        objectType: objectType,
        uiModeProps: uiModeProps,
        viewProps: viewProps,
        skipCrm: skipCrm,
        _useNonGqlCRMSearch: _useNonGqlCRMSearch,
        children: t10
      })
    });
    $[31] = _useNonGqlCRMSearch;
    $[32] = enableObjectLevelPermissions;
    $[33] = objectType;
    $[34] = skipCrm;
    $[35] = t10;
    $[36] = uiModeProps;
    $[37] = viewProps;
    $[38] = t11;
  } else {
    t11 = $[38];
  }
  let t12;
  if ($[39] !== enableFieldLevelPermissions || $[40] !== t11) {
    t12 = /*#__PURE__*/_jsx(CustomerDataPropertiesProvider, {
      enableFieldLevelPermissions: enableFieldLevelPermissions,
      children: t11
    });
    $[39] = enableFieldLevelPermissions;
    $[40] = t11;
    $[41] = t12;
  } else {
    t12 = $[41];
  }
  let t13;
  if ($[42] !== t12 || $[43] !== trackerProps) {
    t13 = /*#__PURE__*/_jsx(ErrorBoundary, {
      fingerprint: SENTRY_KEYS.TOP_LEVEL_LIB_PROVIDER,
      children: /*#__PURE__*/_jsx(UserInfoProvider, {
        children: /*#__PURE__*/_jsx(TrackerProvider, Object.assign({}, trackerProps, {
          children: t12
        }))
      })
    });
    $[42] = t12;
    $[43] = trackerProps;
    $[44] = t13;
  } else {
    t13 = $[44];
  }
  return t13;
}
function _temp3() {
  registerCustomFunction(FOLDERS_MODE_BUTTON_KEY, _temp);
  return _temp2;
}
function _temp2() {
  unregisterCustomFunction(FOLDERS_MODE_BUTTON_KEY);
}
function _temp() {
  var _document$querySelect;
  (_document$querySelect = document.querySelector("[data-test-id=\"crm-listing-ui-mode-button\"][data-test-ui-mode=\"FOLDERS\"]")) === null || _document$querySelect === void 0 || _document$querySelect.click();
}
export default $hasDep('react-dnd', '5') ? FrameworkListingLibProvider :
// eslint-disable-next-line @typescript-eslint/no-var-requires
require('customer-data-ui-utilities/dnd/SharedDragDropContext').default()( /*#__PURE__*/forwardRef((props, __ref) => {
  "use memo";

  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = /*#__PURE__*/_jsx(FrameworkListingLibProvider, Object.assign({}, props));
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}));